<div class="container">
    <div class="side-nav">
        <div class="neo-tabs vertical">
            <div *ngIf="userPrivileges.has('candidate_source.view')" class="neo-tab"
                [class.active]="currentTab() === 'Candidate Source'"
                (click)="switchCurrentTab('Candidate Source')">
                Candidate Source
            </div>
            <div *ngIf="userPrivileges.has('event_category.view')" class="neo-tab" [class.active]="currentTab() === 'Event Category'"
                (click)="switchCurrentTab('Event Category')">
                Event Category
            </div>
            <div *ngIf="userPrivileges.has('event_type.view')" class="neo-tab" [class.active]="currentTab() === 'Event Type'"
                (click)="switchCurrentTab('Event Type')">
                Event Type
            </div>
            <div *ngIf="userPrivileges.has('role_type.view')" class="neo-tab" [class.active]="currentTab() === 'Role Type'" (click)="switchCurrentTab('Role Type')">
                Role Type
            </div>
        </div>
    </div>
    <div class="content-wrapper">
        <div class="content"> 
            <div class="content-title">
                {{currentTab()}}
                <button *ngIf="canCreate" pButton class="create-btn" (click)="openSideBar$.next()">Add New</button>
            </div>
            <div class="content-data neo-scrollbar">
                <app-option-value-add [activeComponent]="currentTab()" [openSideBar$]="openSideBar$"></app-option-value-add>
            </div>
        </div>
    </div>
</div>